import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../shared/AppSettings';
import { shareReplay } from 'rxjs/internal/operators/shareReplay';
import { JournalEditPageSearchResultModel, JournalPageSelectModel, tJournalModel } from '../models/tJournalModel';
import { NavigationComponent } from 'src/app/pages/navigation/navigation.component';


@Injectable({
    providedIn: 'root'
})
export class tJournalService {

    constructor(private http: HttpClient) { }

    baseurl: string = AppSettings.BaseURI;

    readonly pathName = '/tJournal';

    getAllData() {
        return this.http.get<tJournalModel[]>(this.baseurl + this.pathName).pipe(shareReplay(1));
    }

    searchJournalByDayRange(data:any){
        return this.http.post<JournalPageSelectModel[]>(this.baseurl + this.pathName + '/searchJournalByDayRange',data);
    }

    searchJournalByAcctNo(shopID,acctName){
        return this.http.get<JournalPageSelectModel[]>(this.baseurl + this.pathName + '/searchJournalByAcctNo/' + shopID+'/'+acctName);
    }
    searchVoucherNumber(vouNo){
        return this.http.get<JournalPageSelectModel[]>(this.baseurl + this.pathName + '/searchVoucherNumber/'+ NavigationComponent.selectedShopID.toString()+'/' + vouNo);
    }

    searchJournalByVouType(shopID,vouType){
        return this.http.get<JournalPageSelectModel[]>(this.baseurl + this.pathName + '/searchJournalByVouType/' + shopID+'/'+vouType);
    }

    getDataByVoucherID(id: string) {
        return this.http.get<JournalEditPageSearchResultModel>(this.baseurl + this.pathName+'/'+ NavigationComponent.selectedShopID.toString()+ '/' + id);
    }

    newJournal(data: tJournalModel[]) {
        return this.http.post(this.baseurl + this.pathName+ '/newJournal', data);
    }
    editJournal(data:tJournalModel[],vouNo:string) {
        return this.http.post(this.baseurl + this.pathName+ '/editJournal/'+vouNo, data);
    }

    // addData(data: tJournalModel){
    //   return this.http.post(this.baseurl + this.pathName, data);
    // }

     delete(data: tJournalModel){
       return this.http.post(this.baseurl + this.pathName+ '/delete/'+NavigationComponent.selectedShopID.toString()+'/'+data.vouNo,data);
     }

    // updateData(data: tJournalModel){
    //   console.log();
    //   return this.http.put(this.baseurl + this.pathName + '/' + data.shopID, data);
    // }
}